import React from "react";

function LMCREATIONTableau({
  formData,
  handleCheckboxChangeTabeleau,
  handleCheckboxChangeDevis,
}) {
  return (
    <div className="Annexe2">
      {" "}
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th
              style={{
                padding: "8px",
                textAlign: "left",
              }}
            ></th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Client
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Cabinet
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Devis
            </th>
          </tr>
        </thead>
        <tbody>
          <p
            style={{
              fontWeight: "bold",
              margin: "0",
              paddingTop: "10px",
              paddingBottom: "5px",
            }}
          >
            1 / Phase de pré-création
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etape 1 : Prise de connaissance du projet
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdcdpcl"
                checked={formData.pdcdpcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdcdpca"
                checked={formData.pdcdpca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pdcdpo"
                checked={formData.pdcdpo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etape 2 : Elaboration du prévisionnel sur 3 ans
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edps3cl"
                checked={formData.edps3cl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edps3ca"
                checked={formData.edps3ca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edps3o"
                checked={formData.edps3o === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etape 3 : Recherche de financement et assistance à la négociation
              avec les partenaires et financeurs
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdfeaalcl"
                checked={formData.rdfeaalcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdfeaalca"
                checked={formData.rdfeaalca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdfeaalo"
                checked={formData.rdfeaalo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etape 4 : Aide au choix des statuts : juridique, fiscal et social
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aacdscl"
                checked={formData.aacdscl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aacdsca"
                checked={formData.aacdsca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aacdso"
                checked={formData.aacdso === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Rédaction des statuts et des clauses particulières
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdsedcpcl"
                checked={formData.rdsedcpcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdsedcpca"
                checked={formData.rdsedcpca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdsedcpo"
                checked={formData.rdsedcpo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Recherche d’antériorité du nom et de la marque
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rddnedlmcl"
                checked={formData.rddnedlmcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rddnedlmca"
                checked={formData.rddnedlmca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rddnedlmo"
                checked={formData.rddnedlmo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <br />
          <p
            style={{
              fontWeight: "bold",
              margin: "0",
              paddingTop: "10px",
              paddingBottom: "5px",
            }}
          >
            2 / Phase intermédiaire
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etape 5 : Assistance à l’accomplissement des formalités de
              création
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aaldfdccl"
                checked={formData.aaldfdccl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aaldfdcca"
                checked={formData.aaldfdcca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aaldfdco"
                checked={formData.aaldfdco === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Démarches pour obtention des agréments/autorisations préalables
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dpodaapcl"
                checked={formData.dpodaapcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dpodaapca"
                checked={formData.dpodaapca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dpodaapo"
                checked={formData.dpodaapo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Dépôt du capital à la banque
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddcalbcl"
                checked={formData.ddcalbcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddcalbca"
                checked={formData.ddcalbca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddcalbo"
                checked={formData.ddcalbo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <br />
          <p
            style={{
              fontWeight: "bold",
              margin: "0",
              paddingTop: "10px",
              paddingBottom: "5px",
            }}
          >
            3 / Phase post-création
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etape 6 : Organisation administrative et comptable
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="oaeccl"
                checked={formData.oaeccl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="oaecca"
                checked={formData.oaecca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="oaeco"
                checked={formData.oaeco === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etape 7 : Définition et mise en place des outils de gestion
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="demcl"
                checked={formData.demcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="demca"
                checked={formData.demca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="demo"
                checked={formData.demo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <br />
          <p
            style={{
              fontWeight: "bold",
              margin: "0",
              paddingTop: "10px",
              paddingBottom: "5px",
            }}
          >
            Prestations complémentaires
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Élaboration du dossier de financement
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pedd"
                checked={formData.pedd === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Prévisionnel
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pp"
                checked={formData.pp === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Conseils en matière de contrôle interne
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pce"
                checked={formData.pce === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default LMCREATIONTableau;
